import {
  BufferGeometry,
  Material,
  Mesh,
  Object3D,
  Scene,
} from "three";

function materialBrief(m: Material) {
  return {
    uuid: m.uuid,
    name: m.name || "(unnamed)",
    type: m.type,
  };
}

function geometryBrief(g: BufferGeometry | undefined) {
  if (!g) return null;
  const pos = g.getAttribute("position");
  return {
    uuid: g.uuid,
    name: g.name || "(unnamed)",
    type: g.type,
    vertexCount: pos ? pos.count : 0,
  };
}

/**
 * `activeSceneToRender` alt ağacını konsola yazar (mesh’ler push sonrası grupların altında görünür).
 */
export function logSceneToRenderTree(scene: Scene, title: string): void {
  const walk = (obj: Object3D, depth: number) => {
    const pad = "  ".repeat(depth);
    const mesh = obj as Mesh;
    if (mesh.isMesh) {
      const mats = Array.isArray(mesh.material)
        ? mesh.material
        : [mesh.material];
      console.log(`${pad}Mesh`, mesh.name || mesh.id, {
        uuid: mesh.uuid,
        materials: mats.filter(Boolean).map((m) => materialBrief(m!)),
        geometry: geometryBrief(mesh.geometry as BufferGeometry),
      });
    } else {
      console.log(
        `${pad}${obj.type}`,
        obj.name || obj.uuid,
        `(children: ${obj.children.length})`,
      );
    }
    for (const c of obj.children) walk(c, depth + 1);
  };

  console.log(`— ${title} —`);
  walk(scene, 0);
}

/**
 * Materyal önbellek bucket’ları: her materyal için paylaşılan geometri referansları.
 */
export function logMaterialGeometryBuckets(
  buckets: ReadonlyMap<Material, readonly BufferGeometry[]>,
  title: string,
): void {
  console.log(`— ${title} —`, `(bucket sayısı: ${buckets.size})`);
  for (const [mat, geoms] of buckets) {
    console.log(materialBrief(mat), {
      geometryCount: geoms.length,
      geometries: geoms.map((g) => geometryBrief(g)),
    });
  }
}

export function logRenderSceneDebugBundle(options: {
  reason: string;
  structureSignature: string;
  structureRebuilt: boolean;
  sceneToRender: Scene;
  buckets: ReadonlyMap<Material, readonly BufferGeometry[]>;
}): void {
  const {
    reason,
    structureSignature,
    structureRebuilt,
    sceneToRender,
    buckets,
  } = options;
  console.info(
    "[Engine activeSceneToRender]",
    reason,
    "| rebuilt=",
    structureRebuilt,
    "| matBuckets=",
    buckets.size,
    "| renderRootChildren=",
    sceneToRender.children.length,
    "— aşağıdaki grupta ağaç + materyal/geometri",
  );
  console.group(
    `[Engine activeSceneToRender] detay | ${reason} | rebuilt=${structureRebuilt}`,
  );
  console.log("structureSignature", structureSignature);
  console.log(
    "sceneToRender",
    sceneToRender.name,
    sceneToRender.uuid,
    "directChildren:",
    sceneToRender.children.length,
  );
  logMaterialGeometryBuckets(buckets, "Material → geometries (cache)");
  //logSceneToRenderTree(sceneToRender, "Sahne ağacı (şu an GPU’ya gidecek hiyerarşi)");
  console.groupEnd();
}
